var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_816_6610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_816_6610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00118 7.90952C8.33285 7.90952 8.61641 7.79141 8.85185 7.55518C9.08741 7.31896 9.20518 7.03502 9.20518 6.70335C9.20518 6.37168 9.08707 6.08807 8.85085 5.85252C8.61463 5.61707 8.33063 5.49935 7.99885 5.49935C7.66718 5.49935 7.38363 5.61746 7.14818 5.85368C6.91263 6.0899 6.79485 6.3739 6.79485 6.70568C6.79485 7.03735 6.91296 7.32091 7.14918 7.55635C7.38541 7.79179 7.66941 7.90952 8.00118 7.90952ZM8.00002 13.0083C9.30424 11.8408 10.3023 10.7209 10.9942 9.64868C11.6861 8.57646 12.032 7.63735 12.032 6.83135C12.032 5.61602 11.6459 4.6169 10.8737 3.83402C10.1015 3.05113 9.14357 2.65968 8.00002 2.65968C6.85646 2.65968 5.89857 3.05113 5.12635 3.83402C4.35413 4.6169 3.96802 5.61602 3.96802 6.83135C3.96802 7.63735 4.31396 8.57646 5.00585 9.64868C5.69774 10.7209 6.6958 11.8408 8.00002 13.0083ZM8.00002 14.339C6.32224 12.8852 5.06413 11.5323 4.22568 10.2802C3.38724 9.02796 2.96802 7.87835 2.96802 6.83135C2.96802 5.2929 3.46563 4.0474 4.46085 3.09485C5.45618 2.14229 6.63591 1.66602 8.00002 1.66602C9.36413 1.66602 10.5439 2.14229 11.5392 3.09485C12.5344 4.0474 13.032 5.2929 13.032 6.83135C13.032 7.87835 12.6128 9.02796 11.7744 10.2802C10.9359 11.5323 9.6778 12.8852 8.00002 14.339Z",
    fill: "#495054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ef8cd4b548bb50b546ccae86f24ae33f.svg";
export { ForwardRef as ReactComponent };